<template>
  <FriedCard class="edit-after-send-notification">
    <FriedIcon :icon="icon ? icon : 'comments-locked'" />
    <div class="edit-after-send-information">
      <FriedH4>{{ header }}</FriedH4>
      <FriedParagraph>{{ description }}</FriedParagraph>
    </div>
  </FriedCard>
</template>
<script lang="ts">
import type { IconName } from '@getaccept/fried-tofu';
import type { PropType } from 'vue';
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    header: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    icon: {
      type: String as PropType<IconName>,
      default: '',
    },
  },
});
</script>
<style lang="scss" scoped>
.edit-after-send-notification {
  padding: var(--spacing-100) var(--spacing-100);
  display: flex;
  align-items: center;
  color: var(--info-dark);
  box-shadow: none;

  &.card-container {
    background-color: var(--info-light);
  }

  :first-child {
    margin-right: var(--spacing-100);
  }

  .edit-after-send-information > * {
    color: var(--info-dark);
  }
}
</style>
